<template>
<v-card>
  <v-card-title class='subtitle-1 overline' v-text='title' />
  <v-card-text v-text='text' />
</v-card>
</template>
<script>
export default {
  name: 'PlaceHolder',
  props: {
    title: { type: String },
    text: { type: String }
  }
}
</script>
